import { ActionTypes } from "../constants/action-types";

export const setUser = (val) => {
  return {
    type: ActionTypes.SET_USER,
    payload: val,
  };
};
